import Paper from '@mui/material/Paper'
import IconButton from '@mui/material/IconButton'
import Tooltip from '@mui/material/Tooltip'
import { useTranslation } from 'react-i18next'
import { makeStyles } from '@mui/styles'
import { Theme } from '@mui/material/styles'
import { CSSProperties } from 'styled-components'
import { ReactComponent as AimIcon } from '../../icon/current_location.svg'

const useStyles = makeStyles((theme: Theme) => ({
    iconColor: {
        width: '24px',
        height: '24px',
        fill: '#636363',
        '&:hover path': {
            fill: '#318AF1',
        },
        '&:hover circle': {
            fill: '#318AF1',
        },
    },
    iconColorDisabled: {
        fill: '#ffffff',
    },
}))
type MapToolCurrentLocationProps = {
    disabled?: boolean
    onClickCurrentLocation?: () => void
}
const MapToolCurrentLocation = (props: MapToolCurrentLocationProps) => {
    const { disabled, onClickCurrentLocation } = props
    const { t } = useTranslation()
    const classes = useStyles()

    const disabledStyle: CSSProperties = disabled ? { backgroundColor: '#E0E0E0' } : {}

    return (
        <Paper style={disabledStyle} sx={{ mb: '8px' }}>
            <Tooltip title={t('LABEL.MAP.TOOLS.CURRENT_LOCATION') ?? ''} placement="left">
                <IconButton
                    disabled={disabled}
                    sx={{ p: '10px', bgcolor: '#fff', borderRadius: '5px', width: '100%' }}
                    aria-label="directions"
                    onClick={onClickCurrentLocation}
                >
                    <AimIcon className={disabled ? classes.iconColorDisabled : classes.iconColor} />
                </IconButton>
            </Tooltip>
        </Paper>
    )
}

export default MapToolCurrentLocation
